module.exports = __webpack_public_path__ + "media/media/product-card/68e31dc5-9745-4a2f-b242-3bf8d413b178-6527a9496ed5677772ca0cc43fa0d7fa.jpeg";